import InReview from '@/assets/icons/in_review.svg?react';

export default function InReviewBanner() {
  return (
    <div className="bg-secondary-light mt-1 px-3 py-2">
      <div className="flex items-center gap-x-2.5">
        <div className="h-10 w-10">
          <InReview />
        </div>
        <div className="">
          <p className="text-sm font-bold">In review</p>
          <p className="text-xs">
            This receipt is being reviewed by a member from the Enrich Network team. Stay tuned for
            updates
          </p>
        </div>
      </div>
    </div>
  );
}
